import { render, staticRenderFns } from "./AwardModel.vue?vue&type=template&id=18d6bc70&scoped=true"
import script from "./AwardModel.vue?vue&type=script&lang=js"
export * from "./AwardModel.vue?vue&type=script&lang=js"
import style0 from "./AwardModel.vue?vue&type=style&index=0&id=18d6bc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6bc70",
  null
  
)

export default component.exports